import withErrorBoundary from '../ErrorBoundary';

import type { DestinationInfoComponentProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationInfoComponentProps';

import STYLES from './DestinationInfoComponent.module.scss';

const DestinationInfoComponent = ({
  textDescription,
}: DestinationInfoComponentProps) => {
  if (!textDescription) return null;

  return (
    <div
      className={STYLES.DestinationInfoComponent}
      data-testid="destination-info-component"
    >
      {textDescription}
    </div>
  );
};

const DestinationInfoComponentWithErrorBoundary = withErrorBoundary(
  DestinationInfoComponent,
  'destination-info-component',
);

export default DestinationInfoComponentWithErrorBoundary;
